import { render, staticRenderFns } from "./AddTeacherView.vue?vue&type=template&id=2fc9a9e4&scoped=true&"
import script from "./AddTeacherView.vue?vue&type=script&lang=js&"
export * from "./AddTeacherView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc9a9e4",
  null
  
)

export default component.exports